import {
    SET_BULK_ORDER_GRID_COUNT,
    SET_BULK_ORDER_GRID_DATA,
    IS_BULK_ORDER_GRID_LOADING,
    IS_BULK_ORDER_GRID_COUNTS_LOADING
} from "./BulkOrderDashboardType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_BULK_ORDER_GRID_COUNT:
            return {
                ...state,
                bulkOrderGridCount: action.gridCount,
            };
        case SET_BULK_ORDER_GRID_DATA:
            return {
                ...state,
                bulkOrderGridData: action.gridData,
            };
        case IS_BULK_ORDER_GRID_LOADING:
            return {
                ...state,
                isBulkOrderGridLoading: action.flag,
            };
        case IS_BULK_ORDER_GRID_COUNTS_LOADING:
            return {
                ...state,
                isBulkOrderGridCountsLoading: action.flag,
            };
        default:
            return state;
    }
};

export {
    reducers
};